import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

const getAuthHeadersFormData = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    }
  };
};

export const chatService = {
  // Get or create conversation with a pharmacy
  getOrCreateConversation: async (pharmacyId) => {
    const response = await axios.get(
      `${API_URL}/chat/conversation/${pharmacyId}`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Get or create conversation with a customer (for riders)
  getOrCreateRiderConversation: async (customerId) => {
    const response = await axios.get(
      `${API_URL}/chat/rider/conversation/${customerId}`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Get all conversations for customer
  getCustomerConversations: async () => {
    const response = await axios.get(
      `${API_URL}/chat/customer/conversations`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Get all conversations for pharmacy
  getPharmacyConversations: async () => {
    const response = await axios.get(
      `${API_URL}/chat/pharmacy/conversations`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Get messages in a conversation
  getMessages: async (conversationId) => {
    const response = await axios.get(
      `${API_URL}/chat/conversation/${conversationId}/messages`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Send text message
  sendMessage: async (conversationId, content) => {
    const response = await axios.post(
      `${API_URL}/chat/conversation/${conversationId}/message`,
      { content },
      getAuthHeaders()
    );
    return response.data;
  },

  // Send image message
  sendImage: async (conversationId, imageFile) => {
    const formData = new FormData();
    formData.append('image', imageFile);
    
    const response = await axios.post(
      `${API_URL}/chat/conversation/${conversationId}/image`,
      formData,
      getAuthHeadersFormData()
    );
    return response.data;
  },

  // Mark messages as read
  markAsRead: async (conversationId) => {
    const response = await axios.put(
      `${API_URL}/chat/conversation/${conversationId}/read`,
      {},
      getAuthHeaders()
    );
    return response.data;
  },

  // Update conversation status
  updateConversationStatus: async (conversationId, status, orderId = null) => {
    const response = await axios.put(
      `${API_URL}/chat/conversation/${conversationId}/status`,
      { status, orderId },
      getAuthHeaders()
    );
    return response.data;
  },

  // Delete conversation
  deleteConversation: async (conversationId) => {
    const response = await axios.delete(
      `${API_URL}/chat/conversation/${conversationId}`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Create order from chat
  createOrderFromChat: async (conversationId, orderData) => {
    const response = await axios.post(
      `${API_URL}/chat/conversation/${conversationId}/order`,
      orderData,
      getAuthHeaders()
    );
    return response.data;
  },

  // Confirm payment from chat
  confirmPaymentFromChat: async (conversationId, orderId) => {
    const response = await axios.post(
      `${API_URL}/chat/conversation/${conversationId}/payment-confirm`,
      { orderId },
      getAuthHeaders()
    );
    return response.data;
  },

  // Get order status from chat
  getOrderStatusFromChat: async (conversationId) => {
    const response = await axios.get(
      `${API_URL}/chat/conversation/${conversationId}/order-status`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Get all orders from chat
  getAllOrdersFromChat: async (conversationId) => {
    const response = await axios.get(
      `${API_URL}/chat/conversation/${conversationId}/orders`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Get all conversations for rider
  getRiderConversations: async () => {
    const response = await axios.get(
      `${API_URL}/chat/rider/conversations`,
      getAuthHeaders()
    );
    return response.data;
  }
};

